export default __webpack_public_path__ + "static/media/osce-assessment-icon.f5f9e435.svg";